import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { NProgressSpinnerComponent } from './n-progress-spinner.component';

const components = [NProgressSpinnerComponent];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [CommonModule, NgbTooltipModule],
})
export class ProgressSpinnerModule {}
